export const TRENDING_PRODUCTS_TAB_EVENT = 'trendingProductsTabSelect';
